import { useState } from 'react'
import { useController, UseControllerProps } from 'react-hook-form'

import { ExclamationCircleIcon } from '@heroicons/react/20/solid'
import { LockClosedIcon } from '@heroicons/react/24/outline'

interface InputProps extends UseControllerProps {
  label: string
  placeholder?: string
  disabled?: boolean
  prefix: string
}

const InputPrefix = (props: InputProps) => {
  const { label, placeholder, defaultValue, disabled, prefix } = props

  const { field, fieldState } = useController(props)

  const [input, setInput] = useState<string>(
    defaultValue ? String(defaultValue) : ''
  )

  return (
    <div className="col-span-2 flex w-full flex-col">
      <div className="relative col-span-2">
        <div className="col-span-2 w-full rounded-lg bg-white">
          {label && (
            <label
              className={`block text-sm font-medium ${disabled ? 'text-gray-400' : 'text-gray-700'}`}
              htmlFor={label}
            >
              <span className="inline-flex items-center">
                {label}
                {disabled && <LockClosedIcon className="h-4 px-2" />}
              </span>
            </label>
          )}
          <div className="relative text-gray-500">
            <div className="absolute inset-y-0 left-3 my-auto flex h-6 items-center border-r pr-2">
              <span className="h-full rounded-lg text-sm outline-none">
                {prefix}
              </span>
            </div>
            <input
              className={
                (fieldState.error
                  ? 'border-red-300 text-red-900 placeholder-red-300 ' +
                    'focus:border-red-500 focus:ring-red-500'
                  : 'focus:border-gray-600 focus:ring-gray-400') +
                ' w-full appearance-none rounded-lg border bg-transparent pl-[5.5rem] shadow-sm' +
                'block w-full rounded-md outline-none placeholder:text-slate-400 focus:border-slate-600 sm:text-sm' +
                (disabled
                  ? 'border-gray-300 text-gray-400'
                  : 'border-gray-500 text-gray-500')
              }
              onChange={(e) => {
                if (
                  (e.target.value.charCodeAt(e.target.value.length - 1) >= 48 &&
                    e.target.value.charCodeAt(e.target.value.length - 1) <=
                      57) ||
                  (e.target.value.charCodeAt(e.target.value.length - 1) ===
                    46 &&
                    !e.target.value
                      .slice(0, e.target.value.length - 1)
                      .includes('.')) ||
                  e.target.value === ''
                ) {
                  setInput(e.target.value)
                  field.onChange(Number(e.target.value))
                }
              }}
              placeholder={placeholder && placeholder}
              type={'text'}
              value={input}
            />
            {fieldState.error && (
              <>
                <div className="pointer-events-none absolute inset-y-0 right-0 top-2 pr-3">
                  <ExclamationCircleIcon
                    aria-hidden="true"
                    className="h-5 w-5 text-red-500"
                  />
                </div>

                <p className="absolute -bottom-5 flex flex-shrink-0 text-xs text-red-600">
                  {fieldState.error?.message}
                </p>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default InputPrefix
